import { Component, OnInit, OnDestroy } from '@angular/core';
import {Router} from '@angular/router';
import {ProjectService} from '@catcore/services';
import {isNullOrUndefined} from 'util';
import {Project} from '../../../../core/types/api-v2';
import {ExplorerItem, TreeNodeInfo} from '../../../../ui-base/types';
import {ProjectAvodService} from "@catmodels/project-avod/services/project-avod.service";

@Component({
  selector: 'cat-project-avod',
  templateUrl: './project-avod.component.html',
  styleUrls: ['./project-avod.component.scss'],
})
export class ProjectAvodComponent implements OnInit, OnDestroy {

  doAllowCreate = false;
  activeItem = false;
  explorerItems: ExplorerItem[] = [];
  subscription = null;
  project: Project = null;

  constructor(private projectService: ProjectService,
              private router: Router,
              private avodService: ProjectAvodService,
              ) {
  }

  navigateTo(node: TreeNodeInfo) {
    this.router.navigate(node.item.value.route);
  }

  ngOnInit() {
    this.subscription = this.projectService
      .getCurrentProject()
      .subscribe((project: Project) => {
        if (!isNullOrUndefined(project)) {
          this.explorerItems = [];
          this.explorerItems.push(buildDefaultExplorerItem(project, 'AVoD Catalogs', 'project-avod-catalogs'));
          this.explorerItems.push(buildDefaultExplorerItem(project, 'Media Sources', 'project-media-sources'));
        }
      });
    this.avodService.setActive();
  }

  ngOnDestroy() {
    if (!isNullOrUndefined(this.subscription)) {
      this.subscription.unsubscribe();
    }
    this.avodService.setInActive();
  }
}

const buildDefaultExplorerItem = (project: Project, displayName: string, targetRef: string): ExplorerItem => {
  return {label: displayName, value: {route: ['projects', `${project.id}`, 'avod', targetRef]}, expanded: false, allowedActions: []};
};



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/project-avod/components/project-avod/project-avod.component.ts